import { PRESETS_KEY } from './defaults.js'

// Mouse trail from user's custom config — applied to all presets
const _trail = {
    trailRadius: 0.04, trailStrength: 3, trailDissipation: 0.957,
    trailDiffusion: 0.12, trailSoftness: 0, trailIntensity: 3,
}

export const builtinPresets = {
    'Acid Surface': {
        backgroundColor: '#ffffff', exposure: 1.54,
        noiseScale: 1.4, noiseSpeed: 0.13, noiseThreshold: 0.51, noiseSoftness: 0.01,
        pixelSize: 8, mode: 1,
        toonEnabled: true, toonLevels: 4,
        toonColor1: '#005d18', toonColor2: '#00780b', toonColor3: '#00a516', toonColor4: '#c1ff00',
        showPixelUnderneath: true, charBrightnessDelta: 0.8, charDarker: false,
        maskModelOnly: true, materialMode: true,
        lightformerSpeed: 0.9, envMapIntensity: 2.9,
        ..._trail,
    },
    'Pastel': {
        backgroundColor: '#fef6e4', exposure: 1.0,
        noiseScale: 3.5, noiseSpeed: 0.25, noiseThreshold: 0.45, noiseSoftness: 0.2,
        pixelSize: 3, mode: 0,
        toonEnabled: true, toonLevels: 5,
        toonColor1: '#8b5e3c', toonColor2: '#c49a6c', toonColor3: '#e8c4a0', toonColor4: '#fef6e4',
        showPixelUnderneath: true, charBrightnessDelta: 0.15, charDarker: true,
        maskModelOnly: true, materialMode: false,
        lightformerSpeed: 0.6, envMapIntensity: 1.0,
        ..._trail,
    },
    'Frozen': {
        backgroundColor: '#e8f4f8', exposure: 1.2,
        noiseScale: 5.0, noiseSpeed: 0.08, noiseThreshold: 0.55, noiseSoftness: 0.25,
        pixelSize: 3, mode: 0,
        toonEnabled: true, toonLevels: 4,
        toonColor1: '#1a3a4a', toonColor2: '#4a8a9a', toonColor3: '#8acade', toonColor4: '#e8f4f8',
        showPixelUnderneath: true, charBrightnessDelta: 0.2, charDarker: true,
        maskModelOnly: true, materialMode: false,
        lightformerSpeed: 0.2, envMapIntensity: 1.0,
        ..._trail,
    },
    'Gold Engrave': {
        backgroundColor: '#f5f0e1', exposure: 1.4,
        noiseScale: 2.5, noiseSpeed: 0.1, noiseThreshold: 0.45, noiseSoftness: 0.12,
        pixelSize: 5, mode: 1,
        toonEnabled: true, toonLevels: 4,
        toonColor1: '#2a1a00', toonColor2: '#6a4a10', toonColor3: '#b8922a', toonColor4: '#ffe88a',
        showPixelUnderneath: true, charBrightnessDelta: 0.6, charDarker: true,
        maskModelOnly: true, materialMode: true,
        lightformerSpeed: 0.4, envMapIntensity: 2.0,
        ..._trail,
    },
    'Synthwave': {
        backgroundColor: '#ffffff', exposure: 1.6,
        noiseScale: 3.0, noiseSpeed: 0.5, noiseThreshold: 0.35, noiseSoftness: 0.05,
        pixelSize: 5, mode: 1,
        toonEnabled: true, toonLevels: 4,
        toonColor1: '#0a000f', toonColor2: '#4a0066', toonColor3: '#ff0088', toonColor4: '#ffaa00',
        showPixelUnderneath: true, charBrightnessDelta: 0.7, charDarker: false,
        maskModelOnly: true, materialMode: false,
        lightformerSpeed: 1.5, envMapIntensity: 2.8,
        ..._trail,
    },
    'Moss Stone': {
        backgroundColor: '#e8e4d8', exposure: 1.1,
        noiseScale: 3.5, noiseSpeed: 0.06, noiseThreshold: 0.48, noiseSoftness: 0.18,
        pixelSize: 4, mode: 0,
        toonEnabled: true, toonLevels: 4,
        toonColor1: '#1a2a10', toonColor2: '#3a5a20', toonColor3: '#7a9a50', toonColor4: '#c8d8a0',
        showPixelUnderneath: true, charBrightnessDelta: 0.2, charDarker: true,
        maskModelOnly: true, materialMode: true,
        lightformerSpeed: 0.4, envMapIntensity: 1.3,
        ..._trail,
    },
    // --- Synthwave variants ---
    'Neon Horizon': {
        backgroundColor: '#ffffff', exposure: 1.7,
        noiseScale: 2.5, noiseSpeed: 0.4, noiseThreshold: 0.38, noiseSoftness: 0.06,
        pixelSize: 4, mode: 1,
        toonEnabled: true, toonLevels: 4,
        toonColor1: '#06000a', toonColor2: '#2200aa', toonColor3: '#00ccff', toonColor4: '#ff44ff',
        showPixelUnderneath: true, charBrightnessDelta: 0.75, charDarker: false,
        maskModelOnly: true, materialMode: false,
        lightformerSpeed: 1.8, envMapIntensity: 3.0,
        ..._trail,
    },
    'Vaporwave': {
        backgroundColor: '#ffffff', exposure: 1.4,
        noiseScale: 4.0, noiseSpeed: 0.3, noiseThreshold: 0.4, noiseSoftness: 0.1,
        pixelSize: 6, mode: 1,
        toonEnabled: true, toonLevels: 5,
        toonColor1: '#1a0022', toonColor2: '#5500aa', toonColor3: '#ff66aa', toonColor4: '#66ffee',
        showPixelUnderneath: true, charBrightnessDelta: 0.6, charDarker: false,
        maskModelOnly: true, materialMode: false,
        lightformerSpeed: 1.0, envMapIntensity: 2.2,
        ..._trail,
    },
    'Laser Grid': {
        backgroundColor: '#ffffff', exposure: 1.9,
        noiseScale: 3.5, noiseSpeed: 0.33, noiseThreshold: 0.63, noiseSoftness: 0.01,
        pixelSize: 8, mode: 0,
        toonEnabled: true, toonLevels: 3,
        toonColor1: '#000008', toonColor2: '#0044ff', toonColor3: '#ff0066', toonColor4: '#ffffff',
        showPixelUnderneath: true, charBrightnessDelta: 0.8, charDarker: false,
        maskModelOnly: true, materialMode: false,
        lightformerSpeed: 2.0, envMapIntensity: 3.2,
        ..._trail,
    },
    'Outrun': {
        backgroundColor: '#ffffff', exposure: 1.5,
        noiseScale: 2.8, noiseSpeed: 0.35, noiseThreshold: 0.42, noiseSoftness: 0.07,
        pixelSize: 4, mode: 1,
        toonEnabled: true, toonLevels: 4,
        toonColor1: '#08000a', toonColor2: '#880044', toonColor3: '#ff4400', toonColor4: '#ffdd00',
        showPixelUnderneath: true, charBrightnessDelta: 0.65, charDarker: false,
        maskModelOnly: true, materialMode: true,
        lightformerSpeed: 1.3, envMapIntensity: 2.6,
        ..._trail,
    },
    'Electric Dusk': {
        backgroundColor: '#ffffff', exposure: 1.6,
        noiseScale: 3.5, noiseSpeed: 0.45, noiseThreshold: 0.36, noiseSoftness: 0.04,
        pixelSize: 5, mode: 1,
        toonEnabled: true, toonLevels: 4,
        toonColor1: '#0a0510', toonColor2: '#33005a', toonColor3: '#aa00cc', toonColor4: '#00ffaa',
        showPixelUnderneath: true, charBrightnessDelta: 0.7, charDarker: false,
        maskModelOnly: true, materialMode: false,
        lightformerSpeed: 1.6, envMapIntensity: 2.5,
        ..._trail,
    },
    'Chrome Pulse': {
        backgroundColor: '#ffffff', exposure: 2.0,
        noiseScale: 2.0, noiseSpeed: 0.7, noiseThreshold: 0.32, noiseSoftness: 0.02,
        pixelSize: 4, mode: 0,
        toonEnabled: true, toonLevels: 3,
        toonColor1: '#050508', toonColor2: '#cc0055', toonColor3: '#ff8800', toonColor4: '#eeeeff',
        showPixelUnderneath: true, charBrightnessDelta: 0.6, charDarker: false,
        maskModelOnly: true, materialMode: true,
        lightformerSpeed: 2.0, envMapIntensity: 3.5,
        ..._trail,
    },
}

export let userPresets = {}
try {
    userPresets = JSON.parse(localStorage.getItem(PRESETS_KEY)) || {}
} catch(e) {}

export const saveUserPresets = () => {
    localStorage.setItem(PRESETS_KEY, JSON.stringify(userPresets))
}
